import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";

import { i18n } from "../../translate/i18n";
import { CHART_COLORS, channelLabel } from "./format";

const useStyles = makeStyles((theme) => ({
  wrap: { display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" },
  legend: { display: "flex", flexDirection: "column", gap: 6, fontSize: 13, flexGrow: 1 },
  row: { display: "flex", alignItems: "center", gap: 8 },
  dot: { width: 10, height: 10, borderRadius: 5, flexShrink: 0 },
  empty: { fontSize: 14, color: theme.palette.text.secondary, padding: "24px 0", textAlign: "center" },
}));

/** Dona de conversaciones por canal (doc 0447). La usan Resumen y Canales. */
const ChannelDonut = ({ rows }) => {
  const classes = useStyles();
  const channels = (rows || []).map((c) => ({ ...c, name: channelLabel(c.id) }));
  if (channels.length === 0) return <div className={classes.empty}>{i18n.t("reports.empty")}</div>;

  return (
    <div className={classes.wrap}>
      <ResponsiveContainer width={180} height={180}>
        <PieChart>
          <Pie data={channels} dataKey="conversations" nameKey="name" innerRadius={52} outerRadius={80} paddingAngle={2}>
            {channels.map((c, i) => <Cell key={c.id || i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
      <div className={classes.legend}>
        {channels.map((c, i) => (
          <div key={c.id || i} className={classes.row}>
            <span className={classes.dot} style={{ backgroundColor: CHART_COLORS[i % CHART_COLORS.length] }} />
            <span style={{ flexGrow: 1 }}>{c.name}</span>
            <strong>{c.conversations}</strong>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChannelDonut;
